import React from 'react';
import { useIntl } from 'react-intl';

import styles from './FullscreenPrompt.module.css';

interface FullscreenPromptProps {
	onEnter: () => void;
	onDismiss: () => void;
}

export const FullscreenPrompt: React.FC<FullscreenPromptProps> = ({ onEnter, onDismiss }) => {
	const intl = useIntl();

	return (
		<div className={styles.overlay}>
			<div className={styles.box}>
				<div className={styles.icon}>⛶</div>
				<div className={styles.text}>
					{intl.formatMessage({
						id: 'fullscreen.prompt',
						defaultMessage: 'Fullscreen mode is available',
					})}
				</div>
				<button className={styles.accept} onClick={onEnter}>
					{intl.formatMessage({
						id: 'fullscreen.prompt.accept',
						defaultMessage: 'Open in fullscreen',
					})}
				</button>
				<button className={styles.dismiss} onClick={onDismiss}>
					{intl.formatMessage({ id: 'fullscreen.prompt.dismiss', defaultMessage: 'Continue' })}
				</button>
			</div>
		</div>
	);
};
